import { Button } from "@mui/material";
import { AskQuestionIcon } from "Components/Shared/Icons";
import { SupportFlowDialog } from "Components/Support/SupportFlowDialog";
import { SUPPORT_CONFIG } from "Infrastructure/Utils/SupportUtils";
import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";

export const SUPPORT_BUTTON_STYLES = {
  backgroundColor: "#29232f",
  backgroundColorHover: "#352f3b",
  border: "1px solid rgba(41, 35, 47, 0.13)",
  borderRadius: "0 0 10px 10px",
} as const;

export const SupportButton = () => {
  const { t } = useResource();
  const [isOpen, setIsOpen] = useState(false);
  // Remounts the dialog on every open, so each visit starts from the first step. Resetting
  // the flow on close instead would let the closing dialog snap back to the picker while
  // it is still fading out.
  const [flowInstanceKey, setFlowInstanceKey] = useState(0);

  if (!SUPPORT_CONFIG.IS_ENABLED) {
    return null;
  }

  const handleOpen = () => {
    setFlowInstanceKey((key) => key + 1);
    setIsOpen(true);
  };

  return (
    <>
      <Button
        type="button"
        onClick={handleOpen}
        sx={{
          position: "fixed",
          right: "50px",
          bottom: "auto",
          top: "0",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          borderRadius: SUPPORT_BUTTON_STYLES.borderRadius,
          cursor: "pointer",
          fontFamily: "inherit",
          fontSize: ["0.563rem", "0.625rem"],
          fontWeight: "600",
          padding: ["4px 6px", "6px"],
          textDecoration: "none",
          // Below the modal layer on purpose: a floating affordance must not paint over
          // a dialog — and the bottom sheet sits at modal level, so anything above it here
          // would cover the sheet and stay clickable through its backdrop.
          zIndex: ({ zIndex }) => zIndex.appBar,
          color: "white",
          border: SUPPORT_BUTTON_STYLES.border,
          boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
          opacity: "1",
          transition: "opacity 0.1s ease-in-out",
          backgroundColor: SUPPORT_BUTTON_STYLES.backgroundColor,
          "&:hover": {
            backgroundColor: SUPPORT_BUTTON_STYLES.backgroundColorHover,
          },
        }}
      >
        <AskQuestionIcon width={16} height={16} />
        {t(Resources.Support.ButtonLabel)}
      </Button>

      <SupportFlowDialog
        key={flowInstanceKey}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
